import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-exclusive-banners',
    templateUrl: './exclusive-banners.component.html',
    styleUrls: ['./exclusive-banners.component.css'],
    
})
export class ExclusiveBannersComponent implements OnInit {
  @Input() url2;
  @Input() exclusive;
  constructor() { 
    console.log(this.exclusive);
  }

  ngOnInit() {
  }

}
